import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot } from '@angular/router';
import { NeproseService } from '../services/neprose.service';
import { take, mergeMap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlogResolverService implements Resolve<any>{

  constructor( private neproseService: NeproseService, private router: Router) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Observable<never>{
    return this.neproseService.getBlog(route.paramMap.get('slug')).pipe(
      take(1),
      mergeMap(data=> {
        if (data.status) {
          if(data.blog){
            return of(data.blog);
          }else{
            this.router.navigate(['404']);
          }
        } else {
          this.router.navigate(['404']);
        }
      })
    )
  }

}
